import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { AuthClientProvider } from '../../auth/AuthClientProvider';
import { Logger } from '../../utils/Logger';
import { BASE_SPA_API_DEV, BASE_SPA_API_UAT } from '../../feature-components/spa-admin/SPAConstants';

export const postSPARequestServiceAPI = async<T, D>(apiPath: string, payload: D, env: string) => {
    const correlationId = uuidv4();

    var baseUrl = env === 'dev' ? BASE_SPA_API_DEV : BASE_SPA_API_UAT;

    try {
        Logger.Instance.trackTrace(`start PostRequestService ${apiPath}`, {
            baseUrl: baseUrl,
            correlationId: correlationId,
            reqPayload: payload
        });
        const response = await axios.post<T>(`${baseUrl}/${apiPath}`, payload, {
            headers: {
                'Authorization': await AuthClientProvider.getInstance().get_SPA_AuthToken(),
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "CorrelationId": correlationId
            },
        });
        Logger.Instance.trackTrace(`completed PostRequestService ${apiPath}`, {
            baseUrl: baseUrl,
            correlationId: correlationId,
            response: response
        });
        return response;
    } catch (error) {
        Logger.Instance.trackException({ error: error as Error }, {
            event: `error PostRequestService ${apiPath}`,
            baseUrl: baseUrl,
            correlationId: correlationId
        });
        throw error;
    }
};